import { render, staticRenderFns } from "./AddClassRoom.vue?vue&type=template&id=0624bdc0&scoped=true&"
import script from "./AddClassRoom.vue?vue&type=script&lang=js&"
export * from "./AddClassRoom.vue?vue&type=script&lang=js&"
import style0 from "./AddClassRoom.vue?vue&type=style&index=0&id=0624bdc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0624bdc0",
  null
  
)

export default component.exports